import {URL_BASE_API } from '../configs/urlConfigs';
import service from './api';
import axios from 'axios';

export const termsFetch = (request) => {  // FOR SUPERADMIN ONLY
    let ENDPOINT = URL_BASE_API+'user/terms-and-conditions/?group='+request.data.groupId;
    return service.get(ENDPOINT); 
};

export const termsAdd = (request) => { // FOR SUPERADMIN ONLY
  const ENDPOINT = URL_BASE_API+'user/terms-and-conditions/';
  return service.post(ENDPOINT,request.data);
};

export const termsUpdate = (request) => { // FOR SUPERADMIN ONLY
    let termsId = request.data.id; 
    const ENDPOINT = URL_BASE_API+'user/terms-and-conditions/'+termsId;
    return service.put(ENDPOINT,request.data); 
};

export const termsLoad_BKUP = (request) => {  // FOR AFFILIATES AND CLIENTS
  let ENDPOINT = URL_BASE_API+'user/terms-and-conditions-list/?group='+request.data.groupId;
  return service.get(ENDPOINT); 
};

export const termsLoad = (request) => {
  let ENDPOINT = URL_BASE_API+'user/terms-and-conditions-list/?group='+request.data.groupId;

  const parameters = {
    url: ENDPOINT,
    method: 'GET'
  };

  return axios(parameters)
    .then(response => {  
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText
    };
    return errorResp; 
  }); 
};

export const termsAccept = (request) => {
  const ENDPOINT = URL_BASE_API+'user/terms-and-conditions-log/';
  const parameters = {
    url: ENDPOINT,
    method: 'POST',
    headers:{
      'Content-Type': 'application/json'
    },
    data: request.data
  };

  return axios(parameters)
    .then(response => {  
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText
    };
    return errorResp; 
  }); 
};


